import { observable, action, makeObservable } from 'mobx';
import { commentService } from 'config/ioc';
import { PENDING, FULFILLED, REJECTED } from 'constants/actions';

class CommentsStore {
  comments = [];

  fetchState;

  commentFetchState;

  taskId;

  constructor() {
    makeObservable(this, {
      comments: observable.shallow,
      fetchState: observable,
      commentFetchState: observable,
      getComments: action.bound,
      addComment: action.bound,
      createComment: action.bound,
    });
  }

  async getComments(taskId) {
    if (this.taskId === taskId) {
      return;
    }

    this.fetchState = PENDING;

    try {
      const response = await commentService.getComments(taskId);
      this.comments = response.data.data.items;
      this.fetchState = FULFILLED;
      this.taskId = taskId;
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  addComment(message) {
    this.comments = [...this.comments, message];
  }

  async createComment(taskId, message) {
    this.commentFetchState = PENDING;

    try {
      const response = await commentService.createComment(taskId, message);
      const [comment] = response.data.data.items;
      this.addComment(comment);
      this.commentFetchState = FULFILLED;
    } catch (e) {
      this.commentFetchState = REJECTED;
    }
  }
}

const commentsStore = new CommentsStore();

export default commentsStore;
